module.exports = __webpack_public_path__ + "img/logo-dark.919deb7d.svg";